import React, { Component } from 'react'
import "./policy.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiFindWithPagerList , getApiGetDeptList  , getApiGetAreaList ,  getApiGetAllChaPlate } from "../../axios/api"
import { Pagination } from 'antd';
import 'antd/dist/antd.css';


export default class policy extends Component {


    state = {
        banner:[],
        list:[],

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:1,

        key:"",

        showMore:false,
        showMore2:false,
        deptList:[],

        areaList:[],

        area:"",

        deptID:'',
        plate:'',
        plateList:[],
    }

    componentWillMount(){
        window.scroll(0,0);
    }

    componentDidMount(){
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();

        getApiGetAreaList({area:"RegisterArea_HDDQ_Jiangsu_NanJin"}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                if(data){
                    this.setState({
                        areaList:data,
                        area:data[3].areaCode
                    })

                    this.getDept();
                }
            }
        }).catch( err =>{
            console.error(err);
        })
        
        getApiGetAllChaPlate()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                if(data){
                    this.setState({
                        plateList:data,
                        plate:data[0].value
                    })
                }

                // this.changePage(1);
            }
        }).catch( err =>{
            console.error(err);
        })

        
    }

    getDept=()=>{
        setTimeout(()=>{
            getApiGetDeptList({area:this.state.area}) //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
            .then( req =>{
                if(req.data.code === 1){
                    let data = req.data.data;
                    if(data){
                        this.setState({
                            deptList:data
                        })
                    }
                }
            }).catch( err =>{
                console.error(err);
            })

            this.changePage(1)
        },20)
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    changePage=(page)=>{
        this.setState({
            page
        })
        setTimeout(()=>{
            this.getList();
        },50)
    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    gotoInfoPage=(page)=>{
 
        let str = window.location.href;
        var num=str.indexOf("#/") 
        str=str.substr(0,num+1); //取得所有参数   stringvar.substr(start [, length ]

        window.open(str + page);
    }



    getList=()=>{
        let param = {
            area:this.state.area, //RegisterArea_HDDQ_Jiangsu_NanJin RegisterArea_ZXS_Beijing
            page:this.state.page,
            dept:this.state.deptID,
            plate:this.state.plate,
        }

        getApiFindWithPagerList(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.rows,
                    total:data.total
                })
            }else{
                this.setState({list:[],total:0})
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='policy'>
                <Header type={2} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>科创政策</p>
                            </div>

                            <div className='hbox'>
                                <div className='hdiv'>
                                    <h2>地区：</h2>
                                    <div className={this.state.showMore2?'hflex hauto':'hflex'}>
                                        {/* <div onClick={()=>{this.setState({area:""});this.getDept()}} className={this.state.area === ''?'chosn':""}>全部</div> */}
                                        {
                                            this.state.areaList.map((item,index)=>{
                                                return <div key={index} hidden={index < 3} className={this.state.area === item.areaCode?'chosn':""} onClick={()=>{this.setState({area:item.areaCode,deptID:""});this.getDept()}}>{item.areaName}</div>
                                            })
                                        }

                                        <div className='more' onClick={()=>{this.setState({showMore2:!this.state.showMore2})}}>
                                            <p>{this.state.showMore2?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore2?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                                <div className='hdiv'>
                                    <h2>发布单位：</h2>
                                    <div className={this.state.showMore?'hflex hauto':'hflex'}>
                                        <div onClick={()=>{this.setState({deptID:""});this.changePage(1)}} className={this.state.deptID === ''?'chosn':""}>全部</div>
                                        {
                                            this.state.deptList.map((item,index)=>{
                                                return <div key={index} className={this.state.deptID === item.deptName?'chosn':""} onClick={()=>{this.setState({deptID:item.deptName});this.changePage(1)}}>{item.deptName}</div>
                                            })
                                        }

                                        <div hidden={this.state.deptList.length < 6} className='more' onClick={()=>{this.setState({showMore:!this.state.showMore})}}>
                                            <p>{this.state.showMore?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>
                                <div className='hdiv'>
                                    <h2>类型：</h2>
                                    <div className='hflex'>
                                        {
                                            this.state.plateList.map((item,index)=>{
                                                return <div key={index} className={this.state.plate === item.value?'chosn':""} onClick={()=>{this.setState({plate:item.value});this.changePage(1)}}>{item.fullName}</div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='hnum'>
                    <div className='cen'>
                        <div className='hmain'>
                            {/* <div className='htype'>
                                <div className='ht1'>全部</div>
                                <div className='ht2 chosen'>最近7天内截止</div>
                                <div className='ht3'>最近30天内截止</div>
                            </div> */}

                            <h4>共查找到<span>{this.state.total}</span>条信息</h4>
                        </div>
                    </div>
                </div>

                <div className='hpage'>
                    <div className='cen'>
                        <div className='hmain'>
                            <table>
                                <thead>
                                    <tr className='trh'>
                                        <th className='tfd tw2'>政策标题</th>
                                        <th>发布单位</th>
                                        <th>发布时间</th>
                                        {/* <th>原文链接</th> */}
                                    </tr>
                                    <tr className='trh2'>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        {/* <th></th> */}
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    {
                                        this.state.list.map((item,index)=>{
                                            return <tr key={index} onClick={()=>{this.gotoInfoPage('/policyinfo?id='+item.id)}}>
                                                        <td className='tfd'>{item.title}</td>
                                                        <td>{item.dept}</td>
                                                        <td>{item.publishTime}</td>
                                                        {/* <td className='blue'>原文链接</td> */}
                                                    </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                            <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={10}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
